import React, {Suspense, useEffect} from 'react'
import {Canvas, useThree} from '@react-three/fiber'
import { Model } from './model';
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
// let objStl = require("../../threeLoader/index.html");

// let htmlDoc = {__html: objStl};
function AppStlView({src, fileType, styles}) {

    useEffect(() => {
        localStorage.setItem('3dmodal', JSON.stringify({fileType, src}))
    }, [src])
    const CameraController = () => {
        const { camera, gl } = useThree();
        useEffect(
            () => {
                const controls = new OrbitControls(camera, gl.domElement);

                controls.minDistance = 1;
                controls.maxDistance = 100;
                return () => {
                    controls.dispose();
                };
            },
            [camera, gl]
        );
        return null;
    };
    return (
        <div className="App" style={{width: '100%', height:"100%"}}>
            <iframe src={"/sculptgl/index.html"} style={{width: '100%', height:"100%"}}></iframe>
            {/*<Canvas camera={{ position: [0, 10, 80] }} style={{ background: "#393939", width: '100%', height:"100%", ...styles}}>*/}
            {/*    <Suspense fallback={null}>*/}
            {/*        {src ? <Model url={src} /> : ''}*/}
            {/*    </Suspense>*/}
            {/*     <CameraController />*/}
            {/*</Canvas>*/}
        </div>
    );
}

export default AppStlView;
